import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './component/HeroSection';
import IntakeForm from './component/IntakeForm';
import GotQuestion from './component/GotQuestion';

const FormPage = () => {
  return (
    <div className="overflow-hidden">
      <Helmet>
        <title>Forms | New Patient Intake Forms | Guidepost Pediatrics</title>
        <meta
          name="description"
          content="Download new patient intake forms for Guidepost Pediatric Therapies in Wasilla, Alaska. Complete your forms before your first appointment for a smoother experience."
        />
        <meta
          name="keywords"
          content="pediatric therapy forms Wasilla, new patient forms Alaska, therapy intake forms, patient registration forms"
        />
      </Helmet>
      <HeroSection />
      <IntakeForm />
      <GotQuestion />
    </div>
  );
};

export default FormPage;
